module.exports = "You have been outbid on item <a class=\"text-blue\" ng-href=\"{{ notification.data.lot.url }}\">{{ notification.data.lot.name }}</a>\n";